import React from 'react'
import { useTranslation } from 'react-i18next'
import { Breadcrumbs, Crumb } from '@carsys/ui'

export const ReportingBreadCrumbs: React.FC<React.ComponentProps<typeof Breadcrumbs>> = ({ ...props }) => {
  const { t } = useTranslation()
  return (
    <Breadcrumbs {...props}>
      <Crumb data-testid='crumb-reporting' key='crumb-reporting' path='/reporting' text={t('Reporting.Title')} />
      <Crumb
        data-testid='crumb-reporting-report-view'
        key='crumb-reporting-report-view'
        path='/reporting/report/:category/:subCategory/:report/:format'
        text={params => t(`reporting.${params.category}_${params.subCategory}_${params.report}_name`)}
      />
      <Crumb
        data-testid='crumb-reporting-report-view'
        key='crumb-reporting-report-view'
        path='/reporting/time-registration/:report'
        text={params => t(`TimeRegistrationV2.${params.report}_breadcrumb`)}
      />
    </Breadcrumbs>
  )
}

export default ReportingBreadCrumbs
